/**
 * Drop one selected chip and keep every other chip in the same control.
 *
 * Filter selects that sync to the query string rewrite that param to the
 * remaining ids. The param is removed only when the closed chip was the last
 * one. Selects that do not use query params keep their previous clear-on-close
 * bookkeeping, which does not own the parent selection.
 *
 * @param {object} vm
 * @param {object} chosen
 * @param {Array|null|undefined} currentSelection
 */
export function syncModalSelectRemoval(vm, chosen, currentSelection) {
    const current = Array.isArray(currentSelection) ? currentSelection : [];
    const removed = current.find(item => item?.id === chosen?.id) || chosen;
    const usingParentSelection = Array.isArray(vm.alreadySelected) && vm.alreadySelected.length > 0;

    vm.$emit('remove', removed);

    if (!vm.enableQueryParams) {
        vm.selectedFromQuery = [];
        vm.removeQueryParams();

        return;
    }

    const source = usingParentSelection ? vm.alreadySelected : current;
    const remaining = (Array.isArray(source) ? source : []).filter(item => item?.id !== removed?.id);

    vm.selectedFromQuery = remaining;

    if (remaining.length > 0) {
        vm.setQueryParams(remaining);

        return;
    }

    vm.removeQueryParams();
}
